import instance from "./axios";

//大数据中心-公司到期合同基础信息
export const companyBasicInfo = (para) => {
  return instance.get('/contract/companyBasicInfo', {params: para})
}
//大数据中心-欠租合同警示Top5
export const leaseContractTop5 = (para) => {
  return instance.get('/contract/leaseContractTop5', {params: para})
}
//大数据中心-三个月内到期合同列表
export const expireContractList = (para) => {
  return instance.get('/contract/expireContractList', {params: para})
}
//大数据中心-到期合同警示Top5
export const rentArrearsMonitorChart = (para) => {
  return instance.get('/contract/rentArrearsMonitorChart', {params: para})
}
//大数据中心-欠租合同列表
export const rentContractList = (para) => {
  return instance.get('/contract/rentContractList', {params: para})
}
//承租人行业结构列表接口（分页）
export const structureList = (para) => {
  return instance.get('/industrial/structure/list', {params: para})
}
//大数据中心-公司整体租金情况
export const companyRentCount = (para) => {
  return instance.get('/contract/companyRentCount', {params: para})
}
//大数据中心-日租金单价区间分布图接口
export const dailyRentalUnitPriceChart = (para) => {
  return instance.get('/contract/dailyRentalUnitPriceChart', {params: para})
}
//大数据中心-租金营收明细接口
export const rentRevenueDetails = (para) => {
  return instance.get('/contract/rentRevenueDetails', {params: para})
}
//产业业态在总体租金中的占比
export const percentageOfTotalRent = (para) => {
  return instance.get('/contract/percentageOfTotalRent', {params: para})
}
//产业结构分析接口
export const structureAnalysis = (para) => {
  return instance.get('/industrial/structure/analysis', {params: para})
}
//管理资产数柱状图接口
export const getManageAssetCount = (para) => {
  return instance.post('/bigdata/getManageAssetCount', para)
}
//平均出租率接口
export const getAvgRentRate = (para) => {
  return instance.post('/bigdata/getAvgRentRate', para)
}
